import { CircleNotch } from '@styled-icons/fa-solid';
import classnames from 'classnames';
import type { ButtonPropsType } from './type';
import styles from './Button.module.css';

function Button({
  block = false,
  children,
  disable = false,
  ghost = false,
  loading = false,
  prefix,
  size = 'sm',
  radius = 'sm',
  suffix,
  type = 'primary',
  width = 'fitContent',
  htmlType,
  onClick,
  testId,
  className,
}: ButtonPropsType) {
  const getLoadingIconSize = () => {
    switch (size) {
      case 'lg': {
        return 28;
      }
      case 'md': {
        return 24;
      }
      default: {
        return 20;
      }
    }
  };

  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={htmlType || 'button'}
      onClick={onClick}
      disabled={disable || loading}
      data-testid={testId}
      className={classnames(
        styles.root,
        styles[`size-${size}`],
        styles[`variant-${type}${ghost ? '-ghost' : ''}`],
        styles[`radius-${radius}`],
        styles[`width-${width}`],
        block && styles.block,
        className
      )}
    >
      {loading ? (
        <CircleNotch className={styles.loading} size={getLoadingIconSize()} />
      ) : (
        <>
          {prefix}
          <span>{children}</span>
          {suffix}
        </>
      )}
    </button>
  );
}

export default Button;
